module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="btn btn-run fn-run-tests">'+
((__t=( dictionary.runAll ))==null?'':__t)+
'</a>\n<div class="fn-suites"></div>';
}
return __p;
};
